import { useCallback } from "react";
import { getLocaleSelector, setDefaultLocale } from "../reducers/localeReducer";
import type { Locale } from "@project/common";
import { setLocale } from "@project/common";
import { useAppAction, useAppSelector } from "./redux";

export const useSetLocale = () => {
  const setDefault = useAppAction(setDefaultLocale);

  return useCallback((locale: Locale) => {
    setLocale(locale);
    setDefault(locale);
  }, [setDefault]);
};

export const useLocale = () => {
  return useAppSelector(getLocaleSelector);
};
